'use client'

import React, {createContext, useContext, ReactNode, FC, useRef} from 'react'
import {LayoutEvent} from '@app/[lang]/(common-header-footer)/(home)/events'
import triggerAnalytics from '@gamezop/analytics-sdk/client/trigger-analytics'
import {useTagsPageAnalytics} from '@app/[lang]/(common-header-footer)/tags/(tag-page)/[tagName]/[tagId]/get-tag-page-analytics/tag-page-analytics-context'

type AnalyticsContextType = {
  order?: number
  layout: string
  onSlideLeft: () => void
}

const AnalyticsContext = createContext<AnalyticsContextType | undefined>(undefined)

export const useSliderAnalytics = () => {
  const context = useContext(AnalyticsContext)

  // Return a no-op function if not wrapped by the provider
  if (!context) {
    return {onSlideLeft: () => {}}
  }

  return context
}

type AnalyticsProviderProps = {
  children: ReactNode
  order?: number
  layout: string
}

export const SliderAnalyticsProvider: FC<AnalyticsProviderProps> = ({children, order, layout}) => {
  const onSlideLeftTriggered = useRef<boolean>(false)
  const {tagAnalyticsData} = useTagsPageAnalytics()

  const onSlideLeft = () => {
    if (!onSlideLeftTriggered.current) {
      triggerAnalytics(LayoutEvent.Scrolled, {
        layout,
        order,
        ...tagAnalyticsData,
      }).sendAll()
    }
    onSlideLeftTriggered.current = true
  }

  return <AnalyticsContext.Provider value={{order, layout, onSlideLeft}}>{children}</AnalyticsContext.Provider>
}
